var cookieOptions;
var splitHostName = window.location.hostname.split('.');
if (splitHostName.length === 3) {
    cookieOptions = { domain: `.${splitHostName[1]}.${splitHostName[2]}` };
} else if (splitHostName.length === 2) {
    cookieOptions = { domain: `.${splitHostName[0]}.${splitHostName[1]}` };
} else {
    cookieOptions = { domain: window.location.hostname };
}
export default cookieOptions;